import PaidServicesSwitch from './PaidServicesSwitch';

export default PaidServicesSwitch;
